import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 组织列表
export const setOrgPage: Mutation<IModuleState> = (state, payload) => {
  state.orgPage.data = payload.data;
  state.orgPage.total = payload.total;
  state.orgPage.pageNum = payload.pageNum;
  state.orgPage.pageSize = payload.pageSize;
  state.orgPage.loading = !!payload.loading;
};

// 组织详情
export const setOrgInfo: Mutation<IModuleState> = (state, payload) => {
  state.orgInfo.data = payload.data;
  state.orgInfo.loading = !!payload.loading;
};

// 客户类型列表
export const setCustomerTypes: Mutation<IModuleState> = (state, payload) => {
  state.customerTypes.data = payload.data;
  state.customerTypes.loading = !!payload.loading;
};

// 创建订单(新建组织)
export const setOrderResult: Mutation<IModuleState> = (state, payload) => {
  state.orderResult.data = payload.data;
  state.orderResult.loading = !!payload.loading;
};

// 创建或支付订单后返回的组织信息
export const setOrderOrg: Mutation<IModuleState> = (state, payload) => {
  state.orderOrg.data = payload.data;
  state.orderOrg.loading = !!payload.loading;
};

// 计算后的订单价格
export const setOrderPrice: Mutation<IModuleState> = (state, payload) => {
  state.orderPrice.data = payload.data;
  state.orderPrice.loading = !!payload.loading;
};

// 品牌企业列表
export const setOwnerOrgs: Mutation<IModuleState> = (state, payload) => {
  state.ownerOrgs.data = payload.data;
  state.ownerOrgs.loading = !!payload.loading;
};

// 品牌企业的下辖品牌列表
export const setOwnerBrands: Mutation<IModuleState> = (state, payload) => {
  state.ownerBrands.data = payload.data;
  state.ownerBrands.loading = !!payload.loading;
};

// 品牌门店的下辖品牌列表
export const setStoreBrands: Mutation<IModuleState> = (state, payload) => {
  state.storeBrands.data = payload.data;
  state.storeBrands.loading = !!payload.loading;
};

// 待添加的竞品或授权品牌列表
export const setUnauthBrands: Mutation<IModuleState> = (state, payload) => {
  state.unauthBrands.data = payload.data;
  state.unauthBrands.total = payload.total;
  state.unauthBrands.pageNum = payload.pageNum;
  state.unauthBrands.pageSize = payload.pageSize;
  state.unauthBrands.loading = !!payload.loading;
};

// 已保存的授权品牌列表
export const setAuthedBrands: Mutation<IModuleState> = (state, payload) => {
  state.authedBrands.data = payload.data;
  state.authedBrands.total = payload.total;
  state.authedBrands.pageNum = payload.pageNum;
  state.authedBrands.pageSize = payload.pageSize;
  state.authedBrands.loading = !!payload.loading;
};

// 已保存的竞品品牌列表
export const setCompetBrands: Mutation<IModuleState> = (state, payload) => {
  state.competBrands.data = payload.data;
  state.competBrands.total = payload.total;
  state.competBrands.pageNum = payload.pageNum;
  state.competBrands.pageSize = payload.pageSize;
  state.competBrands.loading = !!payload.loading;
};

// 客服沟通列表
export const setExchanges: Mutation<IModuleState> = (state, payload) => {
  state.exchanges.data = payload.data;
  state.exchanges.loading = !!payload.loading;
};

// 添加组织时的表单数据
export const setSteps: Mutation<IModuleState> = (state, payload) => {
  state.steps.step1 = payload.step1;
  state.steps.step2 = payload.step2;
  state.steps.step3 = payload.step3;
  state.steps.step5 = payload.step5;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type || '';
  state.dialog.data = payload.data || null;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.data = payload.data || null;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
